const getFilesFromDropEvent = function({ dataTransfer: { files, items } }) {
  return files.length
    ? [...files]
    : items
        .filter(({ kind }) => kind === "file")
        .map(({ getAsFile }) => getAsFile());
}
export default {
  getFilesFromDropEvent
}